if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.watchTarget = document.getElementById(this.dataset.watchTarget);
        this.priceDestination = this.querySelector('.sticky-add-to-cart__price');
        this.thumbnail = this.querySelector('.sticky-add-to-cart__thumbnail img');
        this.submitButton = this.querySelector('.sticky-add-to-cart__submit');
        this.variantIdInput = this.querySelector('input[name="id"]');
      }

      connectedCallback() {
        if (this.watchTarget && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
            rootMargin: '-1px 0px 0px 0px',
          });
          this.observer.observe(this.watchTarget);
        }

        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribeVariantChange?.();
      }

      handleIntersect(entries) {
        const entry = entries[0];
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', scrolledPast);
      }

      handleVariantChange({ data: { sectionId, html, variant } }) {
        if (sectionId !== this.sectionId) return;

        if (this.variantIdInput) {
          this.variantIdInput.value = variant?.id ?? '';
        }

        if (this.thumbnail && variant?.featured_image) {
          this.thumbnail.src = variant.featured_image.src;
        }

        const sourcePrice = html.getElementById(`price-${sectionId}`);
        if (sourcePrice && this.priceDestination) {
          this.priceDestination.innerHTML = sourcePrice.innerHTML;
        }

        const sourceSubmit = html.getElementById(`ProductSubmitButton-${sectionId}`);
        if (sourceSubmit && this.submitButton) {
          this.submitButton.toggleAttribute('disabled', sourceSubmit.hasAttribute('disabled'));
        }
      }
    }
  );
}
